var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIparhaiLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.74 65.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1 {\r\n                fill: #072a52;\r\n            }\r\n\r\n            .cls-2 {\r\n                fill: #ff6e0d;\r\n            }\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    className: "cls-1 animated-path",
    d: "M279,15.47l3.2.12a20,20,0,0,1,5.63,1,11.84,11.84,0,0,1,6,4.06c1.58,2.13,2.53,4.84,1.14,7.87a8.43,8.43,0,0,1-5.3,4.5h0a17.92,17.92,0,0,1-5.54.72c-.34,0-.68,0-1,0h0a3.81,3.81,0,0,0-3.8,3.81v24A3.47,3.47,0,0,1,275.76,65h0l-7.93,0,.09-27.67a3.5,3.5,0,0,0-3.45-3.5h-.64a3.88,3.88,0,0,0-3.93,3.83v0l-.11,31.58a3.34,3.34,0,0,0,3.32,3.36h0l20.58,0a3.48,3.48,0,0,0,3.49-3.48v-26a2.67,2.67,0,0,1,2.52-2.67l1.21-.07A17,17,0,0,0,296.71,39c3.16-1.39,5-2.72,6.63-5.67,2.11-3.87,3.33-10.29-1.34-17a21.78,21.78,0,0,0-17.87-9.51h-10Z",
    transform: "translate(-255.47 -6.81)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2; 1; 0.2",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    className: "cls-2",
    d: "M259.63,37.43a4.09,4.09,0,0,1,4.05-4.12h.13a4,4,0,0,1,4.35,3.62.34.34,0,0,0,0,.1V49.41l-4.27-4.64-4.27,4.64Z",
    transform: "translate(-255.47 -6.81)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2; 1; 0.2",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    className: "cls-1",
    d: "M255.47,24.1a.82.82,0,0,1,.46-.4L264.22,20a.81.81,0,0,1,.74,0l8.31,3.73c.37.16.58.51.35.85a.29.29,0,0,0,0,.18v4.5a.24.24,0,0,0,.15.24,1.37,1.37,0,1,1-1.35,0,.26.26,0,0,0,.13-.19q0-2.05,0-4.11a.45.45,0,0,0,0-.11l-.18.05c-.58.19-1.15.39-1.74.57a.21.21,0,0,0-.17.24h0v3.52a.62.62,0,0,1-.22.54.63.63,0,0,1-.58.05c-.79-.23-1.58-.48-2.39-.65a13.08,13.08,0,0,0-3.48-.22,15,15,0,0,0-4.23.87.52.52,0,0,1-.7-.23.49.49,0,0,1-.05-.31V26a.26.26,0,0,0-.2-.29h0L256,24.8a.75.75,0,0,1-.5-.4Z",
    transform: "translate(-255.47 -6.81)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2; 1; 0.2",
    dur: "4s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIparhaiLoader);
export default __webpack_public_path__ + "static/media/iparhaiLoader.22322f271529ca513b2a905493cfcb69.svg";
export { ForwardRef as ReactComponent };